import { appendGotoLink } from '@/helpers';
import { store } from './store';

export const categoryStore = {
    state: {
        category: {
            id: null,
            rules: null,
            name: null,
        },
        isLoaded: false,
        scrollCompleted: false,
        clickedPartnerID: {},
        partnersCount: null,
        rankingList: null,
        rankingTableIsLoaded: false,
        bannerPartner: null,
        defaultPartnerCount: 5,
        observer: null,
        sidebarAdBannerObserver: null,
        productIcons: {},
        firstPartnerId: null,
        homePageReviewSlug: null,
        sidebar_billboard_partner: null,
    },
    setCategory(category) {
        this.state.category = category;
    },
    setHomePageReviewSlug(reviewSlug) {
        this.state.homePageReviewSlug = reviewSlug;
    },
    setPartnersCount(count) {
        this.state.partnersCount = count;
    },
    updatePartnerIcons(partner, index) {
        if (partner['partner_icons']) {
            if (index === 0) {
                this.state.firstPartnerId = partner['partner_id'];
            }

            for (let i = 0; i < partner['partner_icons'].length; i++) {
                const name = partner['partner_icons'][i]['name'];
                const url = partner['partner_icons'][i]['url'];
                const partnerId = partner['partner_id'];
                if (this.state.productIcons[name]) {
                    this.state.productIcons[name]['partners'].push(partnerId);
                    continue;
                }
                this.state.productIcons[name] = {
                    url,
                    partners: [partnerId],
                };
            }
        }
        // FRON-1592
        if (partner['cover_image']) {
            try {
                if (
                    window['__dyanmic_template_props__']['Settings'] &&
                    window['__dyanmic_template_props__']['Settings'][
                        'usePartnerCoverImageAsLogo'
                    ]
                ) {
                    partner['logo_image'] = partner['cover_image'];
                }
            } catch (e) {
                // ignore error
            }
        }
    },
    applyProAndConsLogic(partner, index) {
        if (!window['__host__']['pros_and_cons']) return partner;

        if (
            !partner['marketing_properties'] ||
            !partner['marketing_properties']['pros'] ||
            !partner['marketing_properties']['cons']
        ) {
            return partner;
        }

        const limits = [
            { prosCount: 5, consCount: 0 },
            { prosCount: 4, consCount: 0 },
            { prosCount: 3, consCount: 1 },
            { prosCount: 3, consCount: 1 },
            { prosCount: 3, consCount: 1 },
        ];

        const { prosCount = 2, consCount = 2 } = limits[index] || {};

        const extractListItems = (htmlString) => {
            return htmlString
                ? htmlString
                      .match(/<li>(.*?)<\/li>/g)
                      ?.map((item) => item.replace(/<\/?li>/g, '')) || []
                : [];
        };

        const pros = extractListItems(
            partner['marketing_properties']['pros']
        ).slice(0, prosCount);
        const cons = extractListItems(
            partner['marketing_properties']['cons']
        ).slice(0, consCount);

        let combinedListHTML =
            '<ul style="list-style-type: none;padding: 0;margin: 0;">';

        pros.forEach((pro) => {
            combinedListHTML += `<li><span style="color:green;">&#10003;</span> ${pro}</li>`;
        });

        cons.forEach((con) => {
            combinedListHTML += `<li><span style="color:red;">&#10007;</span> ${con}</li>`;
        });

        combinedListHTML += '</ul>';

        partner['description'] = combinedListHTML;

        return partner;
    },

    updateRankingList(partners) {
        if (partners) {
            this.state.rankingList = partners.map((partner, index) => {
                this.updatePartnerIcons(partner, index);
                partner = this.applyProAndConsLogic(partner, index);
                return partner.api_clickout
                    ? partner
                    : appendGotoLink(
                          partner,
                          index,
                          window.canRunAds,
                          store.state.psh,
                          store.state.pageViewId
                      );
            });
            this.state.rankingTableIsLoaded = true;
        } else {
            partners = null;
        }
    },
};
